const togglePublicMenu = (show) => {
    const menu = document.querySelector('.public-mobile-menu');
    const backdrop = document.querySelector('.public-header-backdrop');
    const toggle = document.querySelector('.public-header-menu-toggle');

    if (!menu || !backdrop) return;

    if (show) {
        menu.classList.add('active');
        backdrop.classList.add('active');
        toggle?.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';

        // Focus first link for accessibility
        const firstLink = menu.querySelector('.public-mobile-link');
        if (firstLink) {
            firstLink.focus();
        }
    } else {
        menu.classList.remove('active');
        backdrop.classList.remove('active');
        toggle?.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
    }
};

const handlePublicMenuToggle = () => {
    const menu = document.querySelector('.public-mobile-menu');
    const isOpen = menu?.classList.contains('active');
    togglePublicMenu(!isOpen);
};

const handlePublicMenuClose = () => {
    togglePublicMenu(false);
};

const handlePublicKeydown = (event) => {
    if (event.key === 'Escape') {
        const menu = document.querySelector('.public-mobile-menu');
        if (menu?.classList.contains('active')) {
            togglePublicMenu(false);
        }
    }
};

const initPublicMenu = () => {
    const toggle = document.querySelector('.public-header-menu-toggle');
    const closeBtn = document.querySelector('.public-mobile-menu-close');
    const backdrop = document.querySelector('.public-header-backdrop');

    toggle?.addEventListener('click', handlePublicMenuToggle);
    closeBtn?.addEventListener('click', handlePublicMenuClose);
    backdrop?.addEventListener('click', handlePublicMenuClose);
    document.addEventListener('keydown', handlePublicKeydown);
};

const cleanupPublicMenu = () => {
    const toggle = document.querySelector('.public-header-menu-toggle');
    const closeBtn = document.querySelector('.public-mobile-menu-close');
    const backdrop = document.querySelector('.public-header-backdrop');

    toggle?.removeEventListener('click', handlePublicMenuToggle);
    closeBtn?.removeEventListener('click', handlePublicMenuClose);
    backdrop?.removeEventListener('click', handlePublicMenuClose);
    document.removeEventListener('keydown', handlePublicKeydown);

    // Reset state
    togglePublicMenu(false);
};

$(document).on('turbolinks:load', initPublicMenu);
$(document).on('turbolinks:before-cache', cleanupPublicMenu);
